import React from 'react';
export  default function FooterVersion(){
   const VERSION = process.env.REACT_APP_VERSION || "1.0.0";
   return (
    <span className='text-[11px] opacity-60 whitespace-nowrap'>
      Website Version : {VERSION}
    </span>
  );
}